import React from 'react';
import { observer } from 'mobx-react';

import Section from '../uic/Section';
import { List, Row, Label, Value } from '../uic/list';
import { extendObservable } from 'mobx';

import { parseString } from 'react-native-xml2js';
import session from '../session';

class IcecastSection extends React.Component {
    constructor(props) {
        super(props);
        // Don't call this.setState() here!

        extendObservable(this, {
            serverid: '',
            serverstart: '',
            serverdescription: '',
            servername: '',
            listenerpeak: '',
            listeners: '',
            streamstart: '',
            clientsnumber: 0,
            clients: []
        });
    }

    loadIcecast = async () => {
        try {
            let clientNumberFile = 0;
            let clientsFile = [];

            let xml = await session.realm.fetch('/cgi/icecastclients.cgi');

            parseString(xml, function(err, result) {
                if (result && result.icestats && result.icestats.source[0]) {
                    clientNumberFile = result.icestats.source[0].Listeners;
                    clientsFile = result.icestats.source[0].listener;
                }
            });

            const json = await session.realm.fetch('/cgi/icecaststats.cgi');
            var jsonicecastinfo = JSON.parse(json);

            const settingobj = {
                serverid: jsonicecastinfo.icestats.server_id,
                serverstart: jsonicecastinfo.icestats.server_start,
                serverdescription:
                    jsonicecastinfo.icestats.source.server_description,
                servername: jsonicecastinfo.icestats.source.server_name,
                listenerpeak: jsonicecastinfo.icestats.source.listener_peak,
                listeners: jsonicecastinfo.icestats.source.listeners,
                streamstart: jsonicecastinfo.icestats.source.stream_start,
                clientsnumber: clientNumberFile,
                clients: clientsFile
            };

            Object.assign(this, settingobj);
        } catch (e) {
            console.error('IcecastSection:' + e);
        }
    };

    componentDidMount() {
        this._timer = setInterval(this.loadIcecast, 2000);
    }

    componentWillUnmount() {
        if (this._timer) {
            clearInterval(this._timer);
        }
    }

    renderClients() {
        if (!this.clients) {
            return null;
        }

        return this.clients.map((client, i) => (
            <Row key={i}>
                <Label />
                <Value>{client.IP}</Value>
                <Value>{client.Connected}</Value>
            </Row>
        ));
    }

    render() {
        return (
            <Section title="Icecast Statistics">
                <List>
                    <Row>
                        <Label>Server ID</Label>
                        <Value>{this.serverid}</Value>
                    </Row>
                    <Row>
                        <Label>Server Start</Label>
                        <Value>{this.serverstart}</Value>
                    </Row>
                    <Row>
                        <Label>Server Description</Label>
                        <Value>{this.serverdescription}</Value>
                    </Row>
                    <Row>
                        <Label>Server Name</Label>
                        <Value>{this.servername}</Value>
                    </Row>
                    <Row>
                        <Label>Listener Peak</Label>
                        <Value>{this.listenerpeak}</Value>
                    </Row>
                    <Row>
                        <Label>Listeners</Label>
                        <Value>{this.listeners}</Value>
                    </Row>
                    <Row>
                        <Label>Stream Start</Label>
                        <Value>{this.streamstart}</Value>
                    </Row>
                    <Row>
                        <Label>Number of clients</Label>
                        <Value>{this.clientsnumber}</Value>
                    </Row>

                    <Row>
                        <Label>Listeners</Label>
                        <Value>IP address</Value>
                        <Value>Time Connected [s]</Value>
                    </Row>

                    {this.renderClients()}
                </List>
            </Section>
        );
    }
}

export default observer(IcecastSection);



// WEBPACK FOOTER //
// ./src/sections/IceCastStatistics.js